import React from "react";
import { JobWarning, WarningType } from "../../../../common/api/v1.1/types/jobs";

import { StateCallbacks } from "../state";
import { State } from "../types";

import "./styles.scss";
import { Warning } from "./Warning";

type Props = Readonly<{
  review: boolean;
  state: State;
  warnings: JobWarning[];
  resolveWarning: (warning: JobWarning) => Promise<void>;
  focusDataPoints: () => void;
  stateCallbacks: StateCallbacks;
}>;

export const Warnings = ({ review, state, stateCallbacks, warnings, resolveWarning, focusDataPoints}: Props) => {
  let templates : any = {};
  templates[WarningType.BAD_SUPPORT] = "is supported by entire table.  Please change the support to a specific cell";
  templates[WarningType.STRANGE_VALUE] = "has a value that does not match taxonomy";
  templates[WarningType.INEXACT_VALUE] = "is expected to exactly match the text, but does not";
  templates[WarningType.UNREVIEWED_DOC] = "All data points in this document are machine predictions. This is possible as long as a human reviewed these predictions and submitted as is. This can also be a document that has not been reviewed in which case ML might learn to reproduce errors.";
  templates[WarningType.EMPTY_DOC] = "This document contains no data points at all!";

  if (!warnings) {
    return <></>
  }
  return (
    <div className="flex-container">
      <div>
        {warnings
          .filter(warning => warning.type === WarningType.UNREVIEWED_DOC || warning.type === WarningType.EMPTY_DOC)
          .map(warning => {
          return (
            <Warning
             resolveWarning={resolveWarning}
             warning={warning}
             state={state}
             review={review}
             stateCallbacks={stateCallbacks}
             focusDataPoints={focusDataPoints}
            />
          )
        })}
      </div>
      <div>
        <div className="dp-header">        
          Data point specific warnings
        </div>
        {warnings
        .filter(warning => warning.type !== WarningType.UNREVIEWED_DOC && warning.type !== WarningType.EMPTY_DOC)
        .map(warning => {
          return (
            <Warning
             resolveWarning={resolveWarning}
             warning={warning}
             state={state}
             review={review}
             stateCallbacks={stateCallbacks}
             focusDataPoints={focusDataPoints}
            />
        )})}
      </div>
    </div>
  );
};
Warnings.displayName = "Warnings";
